/**
 * @generated SignedSource<<f05ae3fbfebaff03121a286cfacdc811>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightShortDetailsSegments_segments$data = ReadonlyArray<{
  readonly arrivalAirportCode: string;
  readonly departAirportCode: string;
  readonly departDatetime: string;
  readonly id: string;
  readonly " $fragmentType": "FlightShortDetailsSegments_segments";
}>;
export type FlightShortDetailsSegments_segments$key = ReadonlyArray<{
  readonly " $data"?: FlightShortDetailsSegments_segments$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightShortDetailsSegments_segments">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "FlightShortDetailsSegments_segments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departAirportCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalAirportCode",
      "storageKey": null
    }
  ],
  "type": "FlightSegmentType",
  "abstractKey": "__isFlightSegmentType"
};

(node as any).hash = "e066cd0f2b25294933ff7f4fcdced619";

export default node;
